import { MenuAction } from '@shared/interfaces/header/menu-action';
import { DatabaseBackup, Edit, HousePlug, PlugZap, Unplug } from 'lucide-angular';

export const MeteringPointOverviewActionMenu: MenuAction[] = [
  {
    id: 'edit',
    title: 'Redigér',
    icon: Edit,
    breaker: true,
  },
  {
    id: 'rootdata',
    title: 'Anmod om stamdata',
    icon: DatabaseBackup,
    breaker: true,
  },
  {
    id: 'connect',
    title: 'Tilslut',
    icon: HousePlug,
    iconColor: 'text-green-500',
  },
  {
    id: 'disconnect',
    title: 'Afbryd',
    icon: Unplug,
    iconColor: 'text-red-500',
  },
  {
    id: 'reconnect',
    title: 'Genåbn',
    breaker: true,
    icon: PlugZap,
    iconColor: 'text-theme-secondary',
  },
];
